import { produce } from 'immer';

import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_FIELD_SIGNATURE_SIZE_CHANGE,
  CONTRACT_PROGRESS_FIELD_SIZE_CHANGE,
  CONTRACT_PROGRESS_SIGNATURE_SELECT,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import FieldSize from '@app/store/contract-progress/FieldSize';

export interface ContractProgressFieldSizesState {
  [id: string]: FieldSize;
}

const initialState: ContractProgressFieldSizesState = {};

export default function reducer(
  state: ContractProgressFieldSizesState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_FIELD_SIZE_CHANGE:
      return produce(state, (draft) => {
        const { id, linkedFieldIds, absoluteHeight, absoluteWidth, relativeHeight, relativeWidth } =
          action.payload;
        draft[id] = {
          absoluteHeight,
          absoluteWidth,
          relativeHeight,
          relativeWidth,
        };
        // 필드 사이즈 변경시 사인도장 필드와 같이 사이즈가 동기화 되어야하는 연결된 필드들을 함께 업데이트 합니다.
        linkedFieldIds.forEach((linkedFieldId) => {
          draft[linkedFieldId] = {
            absoluteHeight,
            absoluteWidth,
            relativeHeight,
            relativeWidth,
          };
        });
      });
    case CONTRACT_PROGRESS_FIELD_SIGNATURE_SIZE_CHANGE:
      return produce(state, (draft) => {
        const { absoluteHeight, absoluteWidth, signatureIds } = action.payload;
        signatureIds.forEach((id) => {
          if (id in draft) {
            draft[id].absoluteHeight = absoluteHeight;
            draft[id].absoluteWidth = absoluteWidth;
          }
        });
      });
    case CONTRACT_PROGRESS_SIGNATURE_SELECT:
      return produce(state, (draft) => {
        const { absoluteHeight, absoluteWidth, signatureFieldIds } = action.payload;
        signatureFieldIds.forEach((fieldId) => {
          if (fieldId in draft) {
            draft[fieldId].absoluteHeight = absoluteHeight;
            draft[fieldId].absoluteWidth = absoluteWidth;
          }
        });
      });
    default:
      return state;
  }
}
